import clsx from "clsx";
import { graphql } from "gatsby";
import React, { FC } from "react";

import { SideCtaItems } from "./side-cta-items";

export interface SideCtasProps extends Queries.SideCtasDataFragment {}

export const SideCtas: FC<SideCtasProps> = (props) => {
  return (
    <>
      {/* Desktop version */}
      <SideCtaItems
        isMobile={false}
        className={clsx(
          "hidden lg:flex",
          "flex-col gap-0.5 items-end fixed z-[80] right-0 top-1/2 -translate-y-1/2",
          "translate-x-[calc(100%-50px)] overflow-x-visible"
        )}
        {...props}
      />
      {/* Mobile version */}
      <SideCtaItems
        isMobile={true}
        className="flex lg:hidden gap-3 items-end fixed z-[80] right-4 bottom-6"
        {...props}
      />
    </>
  );
};

export const query = graphql`
  fragment SideCtasData on ContentfulSideCtas {
    supportLabel
    supportPageLink {
      id
    }
    infoLabel
    infoPageLink {
      id
    }
    shareEnabled
  }
`;
